module.exports = __webpack_public_path__ + "img/stamp-paid.66883fcf.svg";